<template>
  <CreateReceitaModal
    v-if="showCreateReceitaModal"
    :codCCustoPai="codCCustoPai"
    @closeModal="closeModal"
  />
  <div class="card mt-4">
    <div class="card-header d-flex align-items-center py-0">
      <h6 class="py-3 mb-0">Receitas</h6>
      <div class="ms-auto my-auto">
        <button
          v-if="orcamentoSelecionado.periodoOrcamento"
          type="button"
          class="btn btn-success"
          title="Nova Receita"
          @click="showCreateReceitaModal = true"
        >
          Nova Receita
        </button>
      </div>
    </div>
    <div class="table-responsive">
      <table class="table table-sm table-striped fs-lg" width="100%">
        <thead class="bg-teal text-white">
          <tr>
            <th class="w-20">Receita</th>
            <th class="w-15 text-center">Valor Proposto</th>
            <th class="w-15 text-center">Valor Reformulado</th>
            <th class="w-45 text-center">Memória de Cálculo</th>
            <th class="w-5 text-center">Ações</th>
          </tr>
        </thead>
        <tbody v-if="receitas.receitas && receitas.receitas.length > 0">
          <tr v-for="receita in receitas.receitas" :key="receita.id">
            <td>{{ receita.nome }}</td>
            <td class="text-center">
              <div
                v-if="periodoOrcamentoProposta"
                class="input-group input-custom"
              >
                <span class="input-group-prepend prefix">R$</span>
                <input
                  type="text"
                  class="form-control text-end"
                  v-maska="'#*'"
                  @input="updateReceita(receita)"
                  v-model="receita.proposta"
                />
                <span class="input-group-prepend sufix">,00</span>
              </div>
              <span v-else>
                {{ moneyToCurrencyBr(receita.proposta) }}
              </span>
            </td>
            <td class="text-center">
              <div
                v-if="periodoOrcamentoReformulacao"
                class="input-group input-custom"
              >
                <span class="input-group-prepend prefix">R$</span>
                <input
                  type="text"
                  class="form-control text-end"
                  v-maska="'#*'"
                  @input="updateReceita(receita)"
                  v-model="receita.reformulacao"
                />
                <span class="input-group-prepend sufix">,00</span>
              </div>
              <span v-else>
                {{ moneyToCurrencyBr(receita.reformulacao) }}
              </span>
            </td>
            <td ref="textarea">
              <textarea
                class="form-control textarea-custom"
                @input="updateReceita(receita)"
                @keypress="resizeTextArea"
                v-model="receita.descricao"
              />
            </td>
            <td class="text-center">
              <button
                v-if="
                  periodoOrcamentoProposta ||
                  (periodoOrcamentoReformulacao && !receita.proposta)
                "
                type="button"
                class="btn btn-outline-danger btn-icon btn-sm rounded-pill"
                title="Excluir"
                @click="deleteReceita(receita.id)"
              >
                <i class="ph-trash"></i>
              </button>
              <span v-else>-</span>
            </td>
          </tr>
          <tr class="fw-bold">
            <td>Total</td>
            <td class="text-center">
              {{ moneyToCurrencyBr(receitas.totais.proposta) }}
            </td>
            <td class="text-center">
              {{ moneyToCurrencyBr(receitas.totais.reformulacao) }}
            </td>
            <td colspan="2"></td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="5" class="text-center">Nenhuma receita encontrada</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import CreateReceitaModal from '@/components/receitas/CreateReceitaModal.vue'
import { mapGetters } from 'vuex'
import { moneyToCurrencyBr } from '@/utils/strings'
import { maska } from 'maska'
import { debounce } from 'lodash'
import PeriodoOrcamentoEnum from '@/enum/periodoOrcamentoEnum'

export default {
  name: 'Receitas',

  props: {
    codCCustoPai: {
      type: String,
      required: true,
    },
  },

  components: {
    CreateReceitaModal,
  },

  directives: { maska },

  data() {
    return {
      showCreateReceitaModal: false,
      moneyToCurrencyBr,
      receitas: {
        receitas: [],
        totais: {},
      },
    }
  },

  computed: {
    ...mapGetters(['orcamentoSelecionado']),

    periodoOrcamentoProposta() {
      return (
        this.orcamentoSelecionado.periodoOrcamento ===
        PeriodoOrcamentoEnum.PROPOSTA
      )
    },

    periodoOrcamentoReformulacao() {
      return (
        this.orcamentoSelecionado.periodoOrcamento ===
        PeriodoOrcamentoEnum.REFORMULACAO
      )
    },
  },

  methods: {
    async getReceitas() {
      try {
        this.receitas = await this.$store.dispatch('getReceitas', {
          codCCustoPai: this.codCCustoPai,
          orcamentoId: this.orcamentoSelecionado.id,
        })

        if (this.receitas.receitas && this.receitas.receitas.length > 0) {
          this.$nextTick(() => {
            this.$refs.textarea.forEach((ta) => {
              ta.firstChild.dispatchEvent(new Event('keypress'))
            })
          })
        }
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },

    async updateReceita(receita) {
      try {
        const response = await this.$store.dispatch('updateReceita', {
          codCCustoPai: this.codCCustoPai,
          orcamentoId: this.orcamentoSelecionado.id,
          receitaId: receita.id,
          receita,
        })

        this.receitas.totais.proposta = this.receitas.receitas.reduce(
          (accumulation, receita) => {
            return accumulation + Number(receita.proposta)
          },
          0,
        )

        this.receitas.totais.reformulacao = this.receitas.receitas.reduce(
          (accumulation, receita) => {
            return accumulation + Number(receita.reformulacao)
          },
          0,
        )

        this.$root.$refs.notification.success(response.message)
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },

    async deleteReceita(receitaId) {
      try {
        const response = await this.$store.dispatch('deleteReceita', {
          codCCustoPai: this.codCCustoPai,
          orcamentoId: this.orcamentoSelecionado.id,
          receitaId,
        })

        this.$root.$refs.notification.success(response.message)

        this.getReceitas()
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },

    resizeTextArea(event) {
      const element = event.target
      element.style.height = '18px'
      element.style.height = `${element.scrollHeight + 2}px`
    },

    closeModal(loadListReceitas) {
      if (loadListReceitas) {
        this.getReceitas()
      }
      this.showCreateReceitaModal = false
    },
  },

  mounted() {
    this.getReceitas()
    this.updateReceita = debounce(this.updateReceita, 400)
  },
}
</script>

<style scoped>
th,
td {
  padding: 6px;
}
</style>
